import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from '@/App';
import { I18nProvider } from '@/lib/i18n';
import { reloadOnServiceWorkerUpdate } from '@/lib/swUpdate';
import { SymbolProvider } from '@/lib/useSymbol';
import '@/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 or a validation error will not fix itself on retry, and retrying
      // makes real failures take four times as long to surface.
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

reloadOnServiceWorkerUpdate();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
      <SymbolProvider>
        <App />
      </SymbolProvider>
    </QueryClientProvider>
    </I18nProvider>
  </StrictMode>,
);
